const ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.base69c9edead8ac869e71b0e3ba.app";
const APPSTORE_URL =
  "https://apps.apple.com/us/app/trainova-gym-partners/id6773907897";

export function AppStoreBadge({ className = "" }) {
  return (
    <a
      href={APPSTORE_URL}
      target="_blank"
      rel="noreferrer"
      data-testid="appstore-badge"
      className={`flex items-center gap-2 rounded-xl bg-black px-3.5 py-2 ring-1 ring-white/10 transition-transform duration-200 hover:scale-[1.04] sm:gap-3 sm:px-5 sm:py-3 ${className}`}
    >
      <svg viewBox="0 0 384 512" fill="#fff" aria-hidden="true" className="h-[22px] w-[22px] flex-shrink-0 sm:h-[26px] sm:w-[26px]">
        <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
      </svg>
      <div className="text-left leading-tight text-white">
        <div className="text-[9px] sm:text-[10px]">Download on the</div>
        <div className="text-sm font-semibold sm:text-lg">App Store</div>
      </div>
    </a>
  );
}

export function GooglePlayBadge({ className = "" }) {
  return (
    <a
      href={ANDROID_URL}
      target="_blank"
      rel="noreferrer"
      data-testid="googleplay-badge"
      className={`flex items-center gap-2 rounded-xl bg-black px-3.5 py-2 ring-1 ring-white/10 transition-transform duration-200 hover:scale-[1.04] sm:gap-3 sm:px-5 sm:py-3 ${className}`}
    >
      <svg viewBox="0 0 512 512" aria-hidden="true" className="h-[22px] w-[22px] flex-shrink-0 sm:h-[26px] sm:w-[26px]">
        <path fill="#00A0FF" d="M25.6 24.3c-4 4.3-6.4 11-6.4 19.6v424.2c0 8.6 2.4 15.3 6.4 19.6l1.4 1.4 237.6-237.6v-5.6L27 22.9l-1.4 1.4z" />
        <path fill="#00E676" d="M344.9 335.6l-79.3-79.3v-5.6l79.3-79.3 1.8 1L440.9 227c26.9 15.3 26.9 40.3 0 55.6l-94.2 53.6-1.8 1z" />
        <path fill="#FF3A44" d="M346.7 334.6L265.6 253.5 25.6 493.5c8.9 9.4 23.5 10.5 40 1.2l281.1-160.1z" />
        <path fill="#FFC107" d="M346.7 172.4L65.6 12.3c-16.5-9.4-31.1-8.2-40 1.2l240 240 81.1-81.1z" />
      </svg>
      <div className="text-left leading-tight text-white">
        <div className="text-[9px] uppercase sm:text-[10px]">Get it on</div>
        <div className="text-sm font-semibold sm:text-lg">Google Play</div>
      </div>
    </a>
  );
}
